import { useState } from "react";
import { withTranslation } from "react-i18next";
import InputField from "../../components/inputField";
import "./styles.css";

const Password = ({ updatePass, setUpdatePass }) => {
  // const [pass, setPass]= useState({})
  return (
    <div className="d-flex flex-column gap-2 px-5">
      <h5 className="text-dark text-center">Change Password</h5>
      <InputField
        placeholder="Current Password"
        type="password"
        width="100%"
        autoComplete={"off"}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setUpdatePass((p) => ({ ...p, oldPassword: v.target.value }))
        }
      />
      <InputField
        placeholder="New Password"
        type="password"
        width="100%"
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setUpdatePass((p) => ({ ...p, password: v.target.value }))
        }
      />
      <InputField
        placeholder="Confirm Password"
        type="password"
        width="100%"
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setUpdatePass((p) => ({ ...p, password2: v.target.value }))
        }
      />
    </div>
  );
};
export default withTranslation()(Password);
